<template>
    <div id="app">
        <router-view />
        <vue-progress-bar />
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
    import ApiService from "@services/api.service";

    export default {
        name: "App",

        created() {
            // If token exists set header
            if (this.$store.getters["users/isLoggedIn"]) {
                ApiService.setAuthHeader();
            }
        }
    };

</script>
